import type { HTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export type BottomActionProps = {
  icon: ReactNode;
  label: string;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const BottomActionButton = forwardRef<HTMLDivElement, BottomActionProps>(
  ({ icon, label, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="button"
        className={twMerge(
          'BottomActionButton px-2 py-3 flex justify-center items-center text-gray-silver hover:text-gray focus:text-gray outline-none',
          className,
        )}
        {...props}
      >
        {label && <span className="prose-xs  text-[14px] font-medium mr-2">{label}</span>}
        {icon}
      </div>
    );
  },
);
